<div class="profile" [attr.aria-busy]="loading">
	<!-- Every brand on the account, the registration one first: its name, website
	     and logo are the account's, so only the owner edits them. -->
	<app-account-brands
		[canEditAccountBrand]="canEditBrandIdentity"
		[accountProfile]="accountProfile"
		(accountBrandSaved)="onAccountBrandSaved()"
		(brandsChanged)="onBrandsChanged()"
	></app-account-brands>

	<!-- !address -->
	<form [formGroup]="contactForm">
		<lo-card heading="Contact">
			<div class="rows">
				<div class="row">
					@if (loading) {
					<span class="lo-type-text-sm-medium label">
						Email address
					</span>
					<lo-skeleton variant="text" width="60%"></lo-skeleton>
					} @else if (!isEditActive2) {
					<span class="lo-type-text-sm-medium label">
						Email address
					</span>
					<span class="lo-type-text-md">
						{{ contactForm.get('current_email')?.value }}
					</span>
					} @else {
					<lo-text-field
						label="Email address"
						placeholder="Email"
						formControlName="email"
						[error]="
							contactForm.get('email').valid
								? ''
								: 'Enter a valid email address'
						"
					></lo-text-field>
					}
				</div>
			</div>

			@if (isEditActive2) {
			<div class="actions" loCardFooter>
				<button
					lo-button
					variant="secondary"
					type="button"
					(click)="toggleEdit2()"
				>
					Cancel
				</button>
				<button lo-button type="button" (click)="saveAddressDetails()">
					Save
				</button>
			</div>
			}
		</lo-card>
	</form>

	<!-- !security -->
	@if (userForm.get('is_google_auth').value == false) {
	<form [formGroup]="securityForm">
		<lo-card heading="Security">
			@if (!isEditActive3) {
			<button
				lo-button
				variant="link"
				size="sm"
				type="button"
				loCardActions
				[disabled]="readOnlyRole || isEditActive2"
				(click)="editName3()"
			>
				Change password
			</button>
			} @if (isEditActive3) {
			<div class="rows">
				<lo-text-field
					label="Current password"
					type="password"
					autocomplete="current-password"
					formControlName="current"
				></lo-text-field>

				<lo-text-field
					label="New password"
					type="password"
					autocomplete="new-password"
					formControlName="password"
				></lo-text-field>

				<lo-text-field
					label="Repeat new password"
					type="password"
					autocomplete="new-password"
					formControlName="confirmPassword"
					[error]="
						securityForm.controls['confirmPassword'].touched &&
						securityForm.controls['confirmPassword'].hasError(
							'NoPasswordMatch'
						)
							? 'Password did not match'
							: ''
					"
				></lo-text-field>

				<ul class="requirements" aria-label="Password requirements">
					@for (rule of passwordRules; track rule.error) {
					<li
						class="lo-type-text-sm"
						[class.is-met]="
							securityForm.controls['password'].touched &&
							!securityForm.controls['password'].hasError(
								'required'
							) &&
							!securityForm.controls['password'].hasError(
								rule.error
							)
						"
					>
						<lo-icon name="lo_check"></lo-icon>
						<span>{{ rule.label }}</span>
					</li>
					}
				</ul>
			</div>
			} @if (isEditActive3) {
			<div class="actions" loCardFooter>
				<button
					lo-button
					variant="secondary"
					type="button"
					(click)="editName3()"
				>
					Cancel
				</button>
				<button
					lo-button
					type="button"
					[disabled]="securityForm.invalid"
					(click)="savePassword()"
				>
					Save
				</button>
			</div>
			}
		</lo-card>
	</form>
	}
</div>
